<div class="container-notification-list" (click)="$event.stopPropagation()">

    <!-- Header: abas + marcar todas -->
    <div class="notification-header">
        <div class="notification-tabs">
            <button
                type="button"
                class="notification-tab"
                [class.active]="activeTab() === 'unread'"
                (click)="setTab('unread')">
                <span class="ra-label-s">{{ 'notificationList.tabUnread' | translate }}</span>
                @if (notificationController.unreadCount() > 0) {
                    <span class="tab-count">{{ notificationController.unreadCount() }}</span>
                }
            </button>
            <button
                type="button"
                class="notification-tab"
                [class.active]="activeTab() === 'read'"
                (click)="setTab('read')">
                <span class="ra-label-s">{{ 'notificationList.tabRead' | translate }}</span>
            </button>
        </div>

        @if (notificationController.unreadCount() > 0) {
            <button type="button" class="mark-all" (click)="markAllAsRead()">
                {{ 'notificationList.markAllAsRead' | translate }}
            </button>
        }
    </div>

    <!-- Corpo -->
    <div class="notification-body">

        <!-- Aba: Não lidas -->
        @if (activeTab() === 'unread') {
            @if (notificationController.unreadLoading() && notificationController.unreadList().length === 0) {
                <ra-loading [size]="'small'" [marginTop]="16" />
            } @else if (notificationController.unreadList().length === 0) {
                <ra-empty
                    [title]="'notificationList.emptyUnreadTitle' | translate"
                    [message]="'notificationList.emptyUnreadMessage' | translate" />
            } @else {
                @for (notification of notificationController.unreadList(); track notification._id) {
                    <div class="card-wrapper clickable" (click)="onCardClick(notification)">
                        <notification-card [notification]="notification" [showPin]="true" />
                    </div>
                }
                @if (notificationController.unreadHasMore()) {
                    <button
                        type="button"
                        class="load-more"
                        [disabled]="notificationController.unreadLoadingMore()"
                        (click)="loadMore()">
                        {{ 'notificationList.loadMore' | translate }}
                    </button>
                }
            }
        }

        <!-- Aba: Lidas -->
        @else {
            @if (notificationController.readLoading() && notificationController.readList().length === 0) {
                <ra-loading [size]="'small'" [marginTop]="16" />
            } @else if (notificationController.readList().length === 0) {
                <ra-empty
                    [title]="'notificationList.emptyReadTitle' | translate"
                    [message]="'notificationList.emptyReadMessage' | translate" />
            } @else {
                @for (notification of notificationController.readList(); track notification._id) {
                    <div class="card-wrapper">
                        <notification-card [notification]="notification" [showPin]="false" />
                    </div>
                }
                @if (notificationController.readHasMore()) {
                    <button
                        type="button"
                        class="load-more"
                        [disabled]="notificationController.readLoadingMore()"
                        (click)="loadMore()">
                        {{ 'notificationList.loadMore' | translate }}
                    </button>
                }
            }
        }
    </div>
</div>
